import axios from 'axios'

const request = axios.create({
    baseURL: 'https://jiyao.vfengyun.com',
    timeout: 10000
})

// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加 token，对请求参数统一加密
request.interceptors.request.use(config => {
    // 如果配置了 useFormData，则使用 application/x-www-form-urlencoded
    if (config.useFormData) {
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
        // 将对象转换为表单格式
        if (config.data && typeof config.data === 'object') {
            const formData = new URLSearchParams();
            for (const key in config.data) {
                if (config.data.hasOwnProperty(key)) {
                    formData.append(key, config.data[key]);
                }
            }
            config.data = formData;
        }
    } else if (!config.headers['Content-Type']) {
        // 默认使用 application/json，如果是上传文件则使用 multipart/form-data
        config.headers['Content-Type'] = 'application/json;charset=utf-8';
    }
    // config.params = config.params ? config.params : {}
    // config.params.timeStamp = parseInt(new Date().getTime() / 1000)
    // config.headers['token'] = user.token;  // 设置请求头
    return config
}, error => {
    return Promise.reject(error)
});

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
    response => {
        let res = response.data;
        // 如果是返回的文件
        if (response.config.responseType === 'blob') {
            return res
        }
        // 兼容服务端返回的字符串数据
        if (typeof res === 'string') {
            res = res ? JSON.parse(res) : res
        }
        return res;
    },
    error => {
        console.log('err' + error) // for debug
        return Promise.reject(error)
    }
)


export default request